// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#back-to-top-button {
  position: fixed;
  cursor: pointer;
  z-index: 1;
  right: 20px;
  bottom: 50px;
  padding: 5px 15px;
  align-items: center;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/common/back-to-top/back-to-top.component.scss"],"names":[],"mappings":"AACA;EACI,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;AAAJ","sourcesContent":["\n#back-to-top-button {\n    position: fixed;\n    cursor: pointer;\n    z-index: 1;\n    right: 20px;\n    bottom: 50px;\n    padding: 5px 15px;\n    align-items: center;\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
